import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {FireflyKind} from "@/modules/redactor/models/firefly/FireflyKind";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {Range} from "@/modules/redactor/models/utils/Range";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";


export class FireflyModelV2 extends BaseObject {

    constructor() {
        super();

        this._kind = null;
        this._level = null;
        this._delayTime = 0;
        this._resetTime = 1;
        this._cooldownTime = 0;

        this._density = "1*D(3)+2";
        this._interval = "1*D(3)+2";
        this._quantity = "1*D(3)+2";
        this._reward = null;

        this._adPlacement = null;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get level() {
        return this._level;
    }

    set level(value) {
        this._level = value;
    }

    get delayTime() {
        return this._delayTime;
    }

    set delayTime(value) {
        this._delayTime = value;
    }

    get resetTime() {
        return this._resetTime;
    }

    set resetTime(value) {
        this._resetTime = value;
    }

    get cooldownTime() {
        return this._cooldownTime;
    }

    set cooldownTime(value) {
        this._cooldownTime = value;
    }

    get density() {
        return this._density;
    }

    set density(value) {
        this._density = value;
    }

    get interval() {
        return this._interval;
    }

    set interval(value) {
        this._interval = value;
    }

    get quantity() {
        return this._quantity;
    }

    set quantity(value) {
        this._quantity = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get adPlacement() {
        return this._adPlacement;
    }

    set adPlacement(value) {
        this._adPlacement = value;
    }

    valid() {

        if (!this.kind || FireflyKind.isNone(this.kind)) {
            return false;
        } else if (FireflyKind.AD.equal(this.kind) && !this.adPlacement) {
            return false;
        }

        if (!this.level || !this.level.valid()) {
            return false;
        }

        if (!Number.isInteger(this.delayTime) || this.delayTime < 0) {
            return false;
        }

        if (!Number.isInteger(this.resetTime) || this.resetTime <= 0) {
            return false;
        }

        if (!Number.isInteger(this.cooldownTime) || this.cooldownTime < 0) {
            return false;
        }

        if (this.density === "") {
            return false;
        }

        if (this.interval === "") {
            return false;
        }

        if (this.quantity === "") {
            return false;
        }

        if (!this.reward || this.reward.empty() || !this.reward.valid()) {
            return false;
        }

        if (this.adPlacement && !RedactorUtils.getAdPlacement(this.adPlacement)) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new FireflyModelV2());
        } else if (target instanceof FireflyModelV2) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(FireflyModelV2, {
    _uid: alias("uid", Schema.primitive()),
    _enabled: alias("enabled", Schema.primitive()),

    _kind: alias("kind", FireflyKind.schema()),
    _level: alias("level", Range.schema()),
    _delayTime: alias("delay_time", Schema.primitive()),
    _resetTime: alias("reset_time", Schema.primitive()),
    _cooldownTime: alias("cooldown_time", Schema.primitive()),

    _density: alias("fn_density", Schema.primitive()),
    _interval: alias("fn_interval", Schema.primitive()),
    _quantity: alias("fn_quantity", Schema.primitive()),
    _adPlacement: alias("ad_placement", Schema.primitive()),
    _reward: alias("reward", RewardModel.schema())
});